import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, FormControl } from 'react-bootstrap';
import Empty from '../../components/Empty.jsx';
import {
  loadingContent,
  permissionsOwnUserContent,
} from '../../components/EmptyStates.jsx';
import OrganizationHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import { PlusButtonIcon } from '../../components/icons/PlusButtonIcon.jsx';
import { AddRoleLink } from '../../components/links/index.jsx';
import PermissionsTable from '../../components/organizations/Users/Permissions/PermissionsTable.jsx';
import UserSubHeaderInfo from '../../components/organizations/Users/UserSubHeaderInfo.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import {
  retrieveRoles,
  searchRoles,
  selectSearchRolesResults,
  selectSearchRolesState,
  updateSearchQuery,
} from '../../modules/roles.js';
import { retrieveUser, selectUser } from '../../modules/users.js';
import {
  selectUser as selectCurrentUser,
  selectUserPermissions,
} from '../../modules/auth.js';

const mapStateToProps = (state, ownProps) => ({
  userId: ownProps.userId,
  currentUser: selectCurrentUser(state),
  user: selectUser(ownProps.userId)(state),
  searchResults: selectSearchRolesResults(state),
  searchSuccess: selectSearchRolesState(state).success,
  permissions: selectUserPermissions(state),
});
const mapDispatchToProps = {
  retrieveUser,
  retrieveRoles,
  searchRoles,
  updateSearchQuery,
};

const PermissionsContainer = (props) => {
  const {
    slug,
    userId,
    user,
    permissions,
    retrieveUser,
    searchSuccess,
    searchResults,
    searchRoles,
    updateSearchQuery,
    currentUser,
  } = props;

  const [isFirstLoading, setIsFirstLoading] = useState(true);

  const handleSearch = (event) => {
    const query = event.target.value;
    updateSearchQuery(query);
    searchRoles(userId, query);
  };

  const renderTable = () => {
    if (isFirstLoading || !searchSuccess)
      return <Empty simplified content={loadingContent} />;
    if (searchSuccess && !searchResults.length) {
      return user.id === currentUser.id ? (
        <Empty simplified content={permissionsOwnUserContent} />
      ) : (
        <div className="component-xl component-bg-white component-border-bottom text-center">
          <h2 className="text-info-brand m-b-16">
            The user has no role assigned.
          </h2>

          <p>
            Click the 'Add New Role' button to begin assigning the user's
            organization and security role(s).
          </p>
        </div>
      );
    }

    return (
      <PermissionsTable
        slug={slug}
        roles={searchResults}
        currentUserId={currentUser.id}
        userId={userId}
      />
    );
  };

  useEffect(() => {
    retrieveUser(userId);
    searchRoles(userId).then(() => setIsFirstLoading(false));
  }, []);

  return (
    <React.Fragment>
      {user ? (
        <React.Fragment>
          <OrganizationHeader
            profileTabs
            slug={slug}
            userId={userId}
            userName={user.fullName}
            employeeId={user.employeeId}
            currentUserId={currentUser.id}
            permissions={permissions}
          />

          <SubHeader flexJustify small>
            <UserSubHeaderInfo user={user} currentUserId={currentUser.id} />
            <div className="flex flex-end" style={{ width: '50%' }}>
              <div
                className="m-l-12"
                style={{ width: '100%', maxWidth: '540px' }}
              >
                <FormControl
                  placeholder="Search"
                  type="text"
                  onChange={handleSearch}
                />
              </div>

              {userId !== currentUser.id ? (
                <AddRoleLink userId={userId}>
                  <Button className="m-l-30 " bsStyle="success">
                    <PlusButtonIcon />
                    Add New Role
                  </Button>
                </AddRoleLink>
              ) : null}
            </div>
          </SubHeader>
        </React.Fragment>
      ) : null}

      {renderTable()}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionsContainer);
